/**
 * Action Panel constants — heights, animation durations, breakpoints.
 */

/** Height of the action panel bar (px) */
export const ACTION_PANEL_HEIGHT = 59

/** Extra bottom padding on Capacitor for safe area (px) */
export const ACTION_PANEL_SAFE_AREA_EXTRA = 20

/** Desktop gap between centered action buttons (px) */
export const ACTION_PANEL_DESKTOP_GAP = 120

/** Animation duration for show/hide transition (ms) */
export const ANIMATION_SHOW_HIDE_MS = 200

/** Animation duration for button cross-fade out (ms) */
export const ANIMATION_CROSSFADE_OUT_MS = 100

/** Animation duration for button cross-fade in (ms) */
export const ANIMATION_CROSSFADE_IN_MS = 150
